import React from 'react';
import { grey } from 'styles/palette';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { Theme } from 'swipeclock-frontend';
import { ThemeProvider } from '@mui/material/styles';
import ModifiedAdapterDateFns from 'components/DayPickerSingleDate/ModifiedAdapterDateFns';
import PropTypes from 'prop-types';

// TODO: remove this once updates have been made to the Theme from swipeclock-frontend
// so that this is no longer needed to prevent the top nav bar from being styled incorrectly
import 'styles/reset.scss';

export default function SwipeclockTheme({ children, styles }) {
  // Note: If you wish to see logging, import config from 'config' and use the following line
  // const isDevelopment = !config.isDeployedBuild;
  return (
    <LocalizationProvider dateAdapter={ModifiedAdapterDateFns}>
      <Theme
        globalStyles={{
          body: { backgroundColor: grey(50) },
          ...styles,
        }}
        provider={ThemeProvider}
        enableLogging={false}
      >
        {children}
      </Theme>
    </LocalizationProvider>
  );
}

SwipeclockTheme.propTypes = {
  children: PropTypes.node,
  styles: PropTypes.object,
};
